angular.module('filters').filter('currencyWithoutFraction', ["$filter", function($filter) {
  return function(amount, symbol) {
    var negative, val;
    negative = amount < 0;
    val = $filter('currency')(Math.abs(amount), symbol).slice(0, -3);
    if (negative) {
      return `-${val}`;
    } else {
      return val;
    }
  };
}]);
